<template>
  <AppContainer id="app-pix-pending-payment">
    <AppLoading :loading="loading">
      <h2 class="h1 fw-bold mb">Realizar pagamento</h2>
      <template v-if="transaction">
        <p class="">
          Escaneie o QR Code abaixo com o aplicativo que deseja realizar o
          pagamento ou copie e cole o código
        </p>
        <div class="center-all mt-4">
          <img :src="transaction.qrcode_image" id="qr-code-img" alt="" />
        </div>
        <PixCodeComponent :code="transaction.pix_code" />
        <div class="row align-items-center">
          <div class="col">
            <h4 class="mb-1 fw-bold">Valor</h4>
          </div>
          <div class="col-auto">R$ {{ transaction.value }}</div>
        </div>
        <hr />
        <div>
          <p class="text-warning">
            <small>
              <i class="fas fa-info-circle me-2"></i>
              O saldo adicionado só pode ser usado para recargas no aplicativo e
              não pode ser estornado.
            </small>
          </p>
        </div>
        <div>
          <p class="">
            <small>
              Ao identificar o pagamento, essa tela será atualizada
              automaticamente
            </small>
          </p>
        </div>
      </template>
    </AppLoading>
  </AppContainer>
</template>

<script lang="ts" setup>
import useOffCanvas from "@/components/Offcanvas/useOffCanvas";
import PixCodeComponent from "@/components/PixCodeComponent.vue";
import usePayment from "@/composables/usePayment";
import useTimeInterval from "@/composables/useTimeInterval";
import useToast from "@/composables/useToast";
import useUser from "@/composables/useUser";
import useWebSocket from "@/composables/useWebSocket";
import { EPaymentStatus, EPaymentType } from "@/enums";
import { IPaymentTransaction } from "@/interfaces";
import paths from "@/router/paths";
import webSocketService from "@/services/WebSocketService";
import { useSessionStore } from "@/store/useSessionStore";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

const props = defineProps<{
  transactionId: string;
}>();

const route = useRoute();
const store = useSessionStore();
const { session } = store;

const { getPmTransaction, loading, savePaymentMethod } = usePayment();
const { toastSuccess } = useToast();
const { closeCanvas, canvasBackPressed } = useOffCanvas();
const { shouldStopInterval, startWatching } = useTimeInterval();
const { syncUser } = useUser();
const { subscribeToEvent, unsubscribeFromChannel } =
  useWebSocket(webSocketService);
const transaction = ref<IPaymentTransaction>();

const getTransaction = () => {
  getPmTransaction(props.transactionId, (response) => {
    transaction.value = response;
    if (response.status.value != EPaymentStatus.paid) {
      return;
    }

    shouldStopInterval.value = true;
    toastSuccess("Seu saldo foi adicionado com sucesso!");
    savePaymentMethod({ payment_type: EPaymentType.balance, card_info: null });
    syncUser();
    handleCanvasNavigation();
  });
};
const handleCanvasNavigation = () => {
  if (route.path == paths.more.root) {
    canvasBackPressed();
  } else {
    closeCanvas();
  }
};
onMounted(() => {
  loading.value = true;
  getTransaction();
  const channelName = `balance_change.${session?.id}`;
  console.log(`[PixPendingPayment] 🔌 Subscribing to channel: ${channelName}`);
  console.log(`[PixPendingPayment] 📡 Event name: balance-update`);
  console.log(`[PixPendingPayment] 👤 Session ID: ${session?.id}`);
  subscribeToEvent(
    channelName,
    "balance-update",
    (event) => {
      const oldBalance = store.currentBalance;
      const newBalance = event.user.balance;
      console.log("🔔 WebSocket: balance_change event received (PixPendingPayment)");
      console.log(`💰 Saldo anterior: R$ ${oldBalance.toFixed(2)}`);
      console.log(`💰 Saldo novo: R$ ${newBalance.toFixed(2)}`);
      console.log(`📊 Diferença: R$ ${(newBalance - oldBalance).toFixed(2)}`);
      store.updateSession({ balance: newBalance });
    }
  );
  startWatching(getTransaction);
});

onMounted(() => {
  unsubscribeFromChannel();
});
</script>
<style scoped>
#qr-code-img {
  width: 200px;
  height: 200px;
}
</style>
